export default __webpack_public_path__ + "static/media/2003.11c67cc3.png";